import { DocumentImport } from '@carbon/icons-react';
import { Button } from '@carbon/react';
import { hasPermission, useAdmin } from '@pos/admin-ui';
import { useTranslation } from '@pos/i18n';
import { Link } from 'react-router';
import { IMPORT_MANAGE } from './importApi';

/** *Import* in a catalog or menu list's toolbar: opens the menu data import, for those who may import. */
export function ImportLinkButton({ brandId }: { brandId?: string }) {
  const { t } = useTranslation();
  const { session } = useAdmin();
  if (!hasPermission(session, IMPORT_MANAGE)) return null;
  const to = brandId ? `/catalog/import?brandId=${encodeURIComponent(brandId)}` : '/catalog/import';
  return (
    <Button as={Link} to={to} kind="ghost" renderIcon={DocumentImport}>
      {t('menuImport.toolbar')}
    </Button>
  );
}
